import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Modal } from "@material-ui/core";
import Specialty from "./Specialty";
import Education from "./Education";
import Experience from "./Experience";
import Projects from "./Projects";
import Contact from "./Contact";
import Fun from "./Fun";
import VizSensor from "react-visibility-sensor";
import Background from "../Img/header.gif";
import Background2 from "../Img/header2.gif";
import Background3 from "../Img/header3.gif";
import Background4 from "../Img/header4.gif";
import Background5 from "../Img/header5.gif";
import Background6 from "../Img/header6.gif";
import Background7 from "../Img/header7.gif";
import Background8 from "../Img/header8.gif";
import Spinner from "../Svg/grid.svg";
import { COLOR_DARK, COLOR_LOW, COLOR_HIGH, COLOR_FONT } from "../constants";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "left",
    width: "100%",
  },
  header: {
    display: "flex",
    height: "100%",
    minHeight: "100vh",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "left",
    position: "relative",
  },
  titleContainer: {
    padding: "40px",
    marginLeft: "auto",
    marginRight: "auto",
    zIndex: 100,
  },
  background: {
    backgroundImage: `url(${backgroundChooser()}), linear-gradient(to bottom, ${COLOR_DARK}, ${COLOR_DARK}, ${COLOR_LOW})`,
    opacity: "70%",
    width: "100%",
    height: "100vh",
    position: "absolute",
    backgroundSize: "cover",
    backgroundBlendMode: "overlay",
    backgroundAttachment: "fixed",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down("xs")]: {
      backgroundAttachment: "scroll",
    },
  },
  name: {
    fontSize: "4rem",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "10px",
    color: COLOR_HIGH,
    zIndex: 100,
  },
  job: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "40px",
    color: COLOR_FONT,
    zIndex: 100,
  },
  LoadingModal: {
    backgroundColor: COLOR_DARK,
    textAlign: "center",
  },
  Spinner: {
    marginTop: "300px",
    outline: "none",
  },
}));

function backgroundChooser() {
  let bg = [
    Background,
    Background2,
    Background3,
    Background4,
    Background5,
    Background6,
    Background7,
    Background8,
  ];

  return bg[Math.floor(Math.random() * 8)];
}

function Content({ setScreen }) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);

  function handleModalClose() {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }

  function specialtyOnChange(isVisible) {
    if (isVisible) {
      setScreen("specialty");
    }
  }

  function educationOnChange(isVisible) {
    if (isVisible) {
      setScreen("education");
    }
  }

  function experienceOnChange(isVisible) {
    if (isVisible) {
      setScreen("experience");
    }
  }

  function projectsOnChange(isVisible) {
    if (isVisible) {
      setScreen("projects");
    }
  }

  function contactOnChange(isVisible) {
    if (isVisible) {
      setScreen("contact");
    }
  }

  function headerOnChange(isVisible) {
    if (isVisible) {
      setScreen("header");
    }
  }

  function funOnChange(isVisible) {
    if (isVisible) {
      setScreen("fun");
    }
  }

  return (
    <div className={classes.content}>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={isLoading}
        onClose={() => {}}
        className={classes.LoadingModal}
      >
        <img
          src={Spinner}
          className={classes.Spinner}
          alt={"spinner"}
          onLoad={handleModalClose()}
        />
      </Modal>
      <VizSensor
        partialVisibility
        offset={{ top: 400, bottom: 400 }}
        onChange={headerOnChange}
      >
        <div className={classes.header}>
          <div className={classes.background}></div>
          <div className={classes.titleContainer}>
            <Typography variant="h3" component="h3" className={classes.name}>
              Ryan W Lee
            </Typography>
            <Typography variant="h3" component="h3" className={classes.job}>
              SOFTWARE ENGINEER
            </Typography>
          </div>
        </div>
      </VizSensor>
      <VizSensor
        partialVisibility
        offset={{ top: 460, bottom: 300 }}
        onChange={specialtyOnChange}
      >
        <Specialty />
      </VizSensor>
      <VizSensor
        partialVisibility
        offset={{ top: 460, bottom: 300 }}
        onChange={educationOnChange}
      >
        <Education />
      </VizSensor>
      <VizSensor
        partialVisibility
        offset={{ top: 460, bottom: 300 }}
        onChange={experienceOnChange}
      >
        <Experience />
      </VizSensor>
      <VizSensor
        partialVisibility
        offset={{ top: 460, bottom: 300 }}
        onChange={projectsOnChange}
      >
        <Projects />
      </VizSensor>
      <VizSensor
        partialVisibility
        offset={{ top: 460, bottom: 300 }}
        onChange={funOnChange}
      >
        <Fun />
      </VizSensor>
      <VizSensor
        partialVisibility
        offset={{ top: 460, bottom: 300 }}
        onChange={contactOnChange}
      >
        <Contact />
      </VizSensor>
    </div>
  );
}

export default Content;
